<div class="modal-dialog">
  <div class="modal-content">
    <div class="modal-header">Delete files</div>

    <div class="modal-body">
      <p class="mb-3">You are about to delete the following files</p>
      <div class="files-table-scroll">
        <table class="cl-table-data cl-table-data-light">
          <thead>
            <tr>
              <th class="cl-table-head cl-p-tiny ">
                Type
              </th>
              <th class="cl-table-head cl-p-tiny ">
                File or folder name
              </th>
              <th class="cl-table-head cl-p-tiny ">
                <div>
                  Last Modified
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            @for (item of items; track item) {
              <tr>
                <td>
                  @if (item.__typename === 'File') {
                    <i class="fas fa-file"></i>
                  }
                  @if (item.__typename === 'Folder') {
                    <i class="fas fa-folder"></i>
                  }
                </td>
                <td>
                  {{ item.name }}
                </td>
                <td>
                  @if (item.__typename === 'File') {
                    {{ item.last_modified | cldate }}
                  }
                </td>
              }
            </tbody>
          </table>
        </div>

      </div>
      <div class="modal-footer">
        <span class="modal-footer-left ">
          <button type="button" class="btn cl-color-secondary it-cancel"
            (click)="dialogRef.close()">
            <span>Cancel</span>
          </button></span>
          <span class="modal-footer-center ">
            <div style="margin-top: -8px;">
              <app-message-field #deleteMsg/>
            </div>
          </span>
          <span class="modal-footer-right ">
            <app-do-button [messageField]="deleteMsg" buttonClass="btn cl-color-primary" (actionTriggered)="this.performDelete($event)">
              <span>Delete</span>
            </app-do-button>

          </span>
        </div>
      </div>
    </div>
